import React from 'react';
import { Modal, Typography, Button } from 'antd';
import ButtonRow from 'components/common/ButtonRow';
import { Capability } from 'types/Capability';

type CapabilityActivationModalProps = {
  capability: Capability;
  action: string;
  isModalVisible: boolean;
  onSubmit: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  closeModal: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};

const CapabilityActivationModal = (props: CapabilityActivationModalProps) => {
  return (
    <Modal
      title={props.action + ' Capability/Specialization'}
      visible={props.isModalVisible}
      onCancel={props.closeModal}
      footer={null}
    >
      <Typography.Paragraph strong>
        Are you sure you want to {props.action.toLowerCase()} this capability/specialization?
      </Typography.Paragraph>
      <Typography.Paragraph>{props.capability.name}</Typography.Paragraph>
      <ButtonRow style={{ marginTop: '2em' }}>
        <Button type="primary" onClick={props.onSubmit}>
          {props.action}
        </Button>
        <Button onClick={props.closeModal}>Cancel</Button>
      </ButtonRow>
    </Modal>
  );
};

export default CapabilityActivationModal;
